import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros/visitas/config'
const APICore = process.env.APIBaseURLCore

const Get = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/`, data, config)

const ParametroConfigVisitasRepository = {
  Get,
  Create,
  Update
}

export default ParametroConfigVisitasRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/parametroConfigVisitas.js